var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 317,
    viewBox: "0 0 532 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8292 89.1036C30.8967 88.5666 18.7142 86.4629 10.7978 77.4909C2.40324 67.9768 -2.26523 54.5221 1.65796 42.4417C5.30843 31.2011 17.2777 25.3757 28.6861 22.4086C37.5113 20.1134 45.2914 25.7776 53.8744 28.8614C64.852 32.8057 79.2124 31.841 84.2703 42.3799C90.1203 54.5693 87.6434 70.4381 78.6789 80.5452C70.0887 90.2305 55.7398 89.6845 42.8292 89.1036Z",
    fill: "#FEB12F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.159 0.554571C460.548 -3.546 509.376 44.9379 526.191 108.889C542.686 171.623 521.766 238.542 478.047 277.763C432.855 318.305 369.194 331.886 325.632 288.813C286.731 250.35 306.602 181.61 322.505 123.969C337.822 68.4504 356.852 4.13087 405.159 0.554571Z",
    fill: "#FEB12F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.423 176.774C141.283 178.807 154.945 207.674 162.433 234.576C168.724 257.176 164.898 281.464 146.683 296.255C124.762 314.056 94.8527 323.994 71.0755 308.76C42.997 290.77 25.8385 257.101 36.0243 225.355C46.3106 193.296 79.8328 174.324 113.423 176.774Z",
    fill: "#FEB12F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseYellow);
export default __webpack_public_path__ + "static/media/base-yellow.cdb6a8a18ef9ced306a14115c0e02ce3.svg";
export { ForwardRef as ReactComponent };